module.exports = __webpack_public_path__ + "img/rococo-track.0d6ef575.svg";